import { Box, CircularProgress } from '@mui/material'
import { Button } from '@ds/components'
import DoneIcon from '@mui/icons-material/Done'
import EditIcon from '@mui/icons-material/Edit'
import { memo } from 'react'

export const BUTTON_STYLES = {
  fontWeight: 500,
  fontSize: 14,
  borderRadius: 99,
}

interface ActionButtonsProps {
  isEditing: boolean
  isLoading?: boolean
  initialLoading?: boolean
  songId: number
  onSave: (songId: number, feeType: 'print' | 'digital') => void
  onCancel: (songId: number, feeType?: 'print' | 'digital') => void
  onEdit: (songId: number, feeType?: 'print' | 'digital') => void
  songHasStatus: boolean
  feeType: 'print' | 'digital'
  isBlocked?: boolean
  processingSongId?: number | null
  approvalDecision?: {
    isApproved: number
  } | null
}

export const ActionButtons = memo(
  ({
    isEditing,
    isLoading,
    initialLoading,
    songId,
    onSave,
    onCancel,
    onEdit,
    songHasStatus,
    feeType,
    isBlocked,
    processingSongId,
    approvalDecision,
  }: ActionButtonsProps) => {
    const isCurrentSongProcessing = isLoading && processingSongId === songId
    const isOtherSongProcessing =
      isLoading && processingSongId !== null && processingSongId !== songId

    if (isEditing && !initialLoading) {
      return (
        <Box display="flex" alignItems="center" gap={2}>
          <Box display="flex" gap={1}>
            <Button
              variant="contained"
              color="inherit"
              startIcon={isLoading ? <CircularProgress size={20} /> : <DoneIcon />}
              onClick={() => onSave(songId, feeType)}
              disabled={isCurrentSongProcessing || isBlocked}
              sx={{
                ...BUTTON_STYLES,
                color: 'background.paper',
                bgcolor: isEditing ? 'primary.main' : 'inherit',
                width: 80,
              }}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => onCancel(songId, feeType)}
              disabled={isCurrentSongProcessing || isBlocked}
              sx={{
                ...BUTTON_STYLES,
                width: 80,
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      )
    }

    const isApproved = approvalDecision?.isApproved === 1
    const isRejected = approvalDecision?.isApproved === 0
    const hasApprovalDecision = isApproved || isRejected

    return (
      <Box>
        {!songHasStatus && !initialLoading && !hasApprovalDecision ? (
          <Button
            variant="contained"
            color="primary"
            startIcon={<EditIcon />}
            onClick={() => onEdit(songId, feeType)}
            disabled={isCurrentSongProcessing || isOtherSongProcessing || isBlocked}
            sx={{
              ...BUTTON_STYLES,
              width: 150,
            }}
          >
            Counteroffer
          </Button>
        ) : (
          <Box width={150} />
        )}
      </Box>
    )
  },
)
